export default __webpack_public_path__ + "assets/hill2.png";